import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=e07b56ce&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"
import style0 from "./Widget.vue?vue&type=style&index=0&id=e07b56ce&prod&lang=scss"
import style1 from "./Widget.vue?vue&type=style&index=1&id=e07b56ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07b56ce",
  null
  
)

export default component.exports